import { combineReducers } from '@reduxjs/toolkit'
import userSlice, { USER_STORE_NAME } from './slices/userSlice'
import todoSlice, { TODO_STORE_NAME } from './slices/todoSlice'
import toastSlice, { TOAST_STORE_NAME } from './slices/toastSlice'
import memoSlice, { MEMO_STORE_NAME } from './slices/memoSlice'
import suggestionSlice, {
  SUGGESTION_STORE_NAME,
} from './slices/suggestionSlice'
import locationSlice, { LOCATION_STORE_NAME } from './slices/locationSlice'
import keepSlice, { KEEP_STORE_NAME } from './slices/keepSlice'

export const rootReducer = combineReducers({
  [USER_STORE_NAME]: userSlice,
  [TODO_STORE_NAME]: todoSlice,
  [KEEP_STORE_NAME]: keepSlice,
  [TOAST_STORE_NAME]: toastSlice,
  [MEMO_STORE_NAME]: memoSlice,
  [LOCATION_STORE_NAME]: locationSlice,
  [SUGGESTION_STORE_NAME]: suggestionSlice,
})
